import { appBottomClearanceClass } from "@/components/common/appBottomClearance";
import type { FormViewT } from "@patient-watch/types";
import { createFileRoute } from "@tanstack/react-router";
import { selectPublishedFormsQueryOptions } from "../../features/forms/api/selectForms";
import { PublishedFormsTable } from "@/features/forms/components/PublishedFormsTable";

const websiteUrl = import.meta.env.VITE_WEBSITE_URL || "https://patient.watch";

export const Route = createFileRoute("/forms/")({
    component: () => {
        const { forms } = Route.useLoaderData();
        return (
            <section className={`px-2 pt-2 md:px-4 md:pt-4 ${appBottomClearanceClass}`}>
                {forms && (
                    <PublishedFormsTable
                        // The joined column list is a plain string, so the client cannot infer the row type.
                        forms={forms as unknown as FormViewT[]}
                        websiteUrl={websiteUrl.replace(/\/$/, "")}
                    />
                )}
            </section>
        );
    },
    loader: async ({ context }) => {
        const forms = await context.queryClient.ensureQueryData(selectPublishedFormsQueryOptions());
        return { forms };
    },
});
